import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StoreProvider } from "@/contexts/StoreContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Wishlist from "@/pages/Wishlist";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import Admin from "@/pages/Admin";
import Lookbook from "@/pages/Lookbook";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Shipping from "@/pages/Shipping";
import SizeGuide from "@/pages/SizeGuide";
import Care from "@/pages/Care";
import Stockists from "@/pages/Stockists";
import Press from "@/pages/Press";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";

function App() {
    return (
        <div className="App">
            <StoreProvider>
                <BrowserRouter>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/shop/:category" element={<Shop />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/wishlist" element={<Wishlist />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/checkout/success" element={<CheckoutSuccess />} />
                            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/lookbook" element={<Lookbook />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/shipping" element={<Shipping />} />
                            <Route path="/size-guide" element={<SizeGuide />} />
                            <Route path="/care" element={<Care />} />
                            <Route path="/stockists" element={<Stockists />} />
                            <Route path="/press" element={<Press />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/cookies" element={<Cookies />} />
                            <Route path="/terms" element={<Terms />} />
                        </Routes>
                    </Layout>
                    <Toaster position="bottom-right" />
                </BrowserRouter>
            </StoreProvider>
        </div>
    );
}

export default App;
